import styled from 'styled-components';
import { colors, dimensions } from 'modules/common/styles';
import { SortItem } from 'modules/theme';
import { typography } from 'modules/theme';

const imageSize = 30;
const unitSpace = `${dimensions.unitSpacing}px`;

const Members = styled.div`
  padding-top: ${dimensions.unitSpacing - 5}px;
`;

const MemberImg = styled.img`
  width: ${imageSize}px;
  height: ${imageSize}px;
  border-radius: ${imageSize / 2}px;
  background: ${colors.bgActive};
  border: 2px solid ${colors.colorWhite};
  margin-left: -8px;

  &:first-child {
    margin-left: 0;
  }
`;

const DataWrapperClass = styled.div`
  section.sc-iELTvK.dgWnOn {
    background: #fff;
    margin-left: 20px;
    margin-right: 20px;
  }
  section.sc-jtRfpW.daxgFZ {
    margin-right: 20px;
  }
  section.sc-iELTvK.dstvIj {
    background: #fff;
    margin-left: 20px;
  }

  .addClass:after{
    content:'';
    position:absolute;
    top:0px;
    left:0;
    width:100%;
    height:100%;
    background:#000000bf;
    background-image: url(/images/icons/modal_stream_logo.png);
    background-repeat: no-repeat;
    background-size: 461px 598px;
    background-position: 35% 50%;
    z-index: 99;
  }

  @media (max-width: 760px)
  {
    // margin-left: -70px;
  }
`;

const More = MemberImg.withComponent('span').extend`
  color: ${colors.colorWhite};
  text-align: center;
  vertical-align: middle;
  font-size: ${dimensions.unitSpacing}px;
  background: ${colors.colorCoreLightGray};
  display: inline-block;
  line-height: ${dimensions.coreSpacing + 6}px;
  cursor: pointer;
`;

const QuestionsContainer = styled.div`
  h3 {
    text-transform: uppercase;
    color: ${colors.colorCoreLightGray};
    font-size: 11px;
    padding: 10px 20px;
    margin: 0;
    height: 100%;
  }

  ${SortItem} {
    margin-bottom: -1px;
    border: 0;
    border-top: 1px solid ${colors.borderPrimary};
    border-bottom: 1px solid ${colors.borderPrimary};
    padding-left: 20px;
    padding-right: 20px;
  }
`;

const HeaderData = styled.div`
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 30px;
    background: #f4fafd;

    h6 {
      font-weight: 700;
      font-size: 24px;
      line-height: 33px;
      letter-spacing: 0.2em;
      text-transform: uppercase;
    }
`;

const InsightWrapper = styled.div`
  // position: absolute;
  // right: 0;
  // top: 0;
  // bottom: 0;
  // left: 0;
  // display: flex;
  // flex-direction: column;
  // flex: 1;
  // min-width: 480px;
  // border-radius: 20px;
  // margin-right: 20px;
  // margin-left: 20px;
  // width: 91%;
  background: #f2f2f2;
    //border-radius: 20px 0px 0px 20px;
    position: fixed;
    height: 100%;
    width: 460px;
    right: 0px;
    top: 0px;
    z-index: 99999;
    box-shadow: -10px 0px 20px rgb(0 0 0 / 10%);
    @media only screen and (max-width: 767px) {
      border-radius: 20px 20px 0px 20px;
      width: 395px;
    }

    .filter-header-bar{
      cursor: pointer;
      z-index: 999 ;
      position: absolute;
      left: -58px;
      background: #2B3C93;
      color: #fff;
      display: flex;
      padding: 12px 15px 12px 19px;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
`;

const InsightContent = styled.div`
  overflow: auto;

  .summ h5 {
    margin-left: 20px;
  }
`;

const InsightRow = styled.div`
  position: relative;
  // margin-bottom: 24px;

  div {
    margin: 0px;
  }
  .titleCard h5 {
    padding: 0;
    margin: 0;
  }
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  @media (max-width: 760px)
  {
    display: block;
  }
`;

const FlexItem = styled.div`
@media (max-width: 760px)
{
  margin-left: 0px;
  margin-bottom: 10px;
}
.FilterModalBtn {
  width: 47%;
  justify-content: center;
}
  flex: 1;
  margin: 0;
  margin-left: ${dimensions.coreSpacing}px;

  &:first-child {
    margin-left: 0;
  }

  .form-control {
    box-shadow: none;
    border-radius: 0;
    border: none;
    background: none;
    border-bottom: 1px solid ${colors.colorShadowGray};
    padding: 17px 14px;
    font-size: 13px;

    &:focus {
      box-shadow: none;
      border-color: ${colors.colorPrimary};
    }
  }


`;

const ItemSearch = styled.div`
  input {
    border-left: none;
    border-right: none;
    border-top: none;
    height: 34px;
    padding: 10px;
    border-radius: 0px;
  }
`;

const InsightFilter = styled.div`
  padding: 20px 30px;
  // border-bottom: 1px solid ${colors.borderPrimary};
  background: ${colors.colorWhite};
  border-radius: 10px;

  h5 {
    margin-top: 0;
  }
`;

const InsightTitle = styled.h5`
  text-transform: uppercase;
  font-weight: 500;
  padding: ${dimensions.unitSpacing}px 0;
  // margin: ${dimensions.coreSpacing}px 0 ${dimensions.unitSpacing}px;
  font-weight: 700;
  color: ${colors.colorPrimary}

  span {
    margin-left: ${dimensions.unitSpacing}px;
  }
`;

const InlineItems = styled.div`
  display: flex;
  margin-bottom: ${unitSpace};
  align-items: center;
  justify-content: space-between;

  > div {
    margin-right: ${unitSpace};
  }
`;

const ChartWrapper = styled.div`
  padding: ${dimensions.coreSpacing}px;
  border: 1px solid ${colors.borderPrimary};
  border-radius: 10px;
  background: ${colors.colorWhite};
  width: 100%;
  height: ${props => (props.height ? `${props.height}px` : 'auto')}
  position: relative;
  overflow: hidden;
`;

const LoaderWrapper = ChartWrapper.extend`
  padding: ${dimensions.coreSpacing * 2}px;
`;


const SoundButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;


export const TabItemsStyle = styled.div`
  height: 100%;
  width: 100%;
  .tabItemStyle {
    display: flex;
    // align-items: flex-end;
    // height: 52px;
    // padding: 0px 20px;
    // border-bottom: 1px solid rgb(226, 232, 239);
  }

  .tab-content,
  .tab-pane {
    height: 100%;
  }

  .tabItemStyle > div {
    width: 100%;
    // height: calc(100% - 8px);
    // display: flex;
    // -webkit-box-align: center;
    // align-items: center;
    // position: relative;
    // flex-flow: row-reverse wrap;
    // -webkit-box-pack: start;
    // justify-content: flex-start;
  }

  .tabItemStyle > div > ul {
    display: flex;
    flex-direction: row;
    -webkit-box-pack: start;
    justify-content: flex-start;
    -webkit-box-align: center;
    align-items: center;
    flex: 1 1 0%;
    border: none;
    border-bottom: 1px solid rgb(226, 232, 239);
    padding: 30px 20px 0px 20px;
  }

  ul > li > a {
    position: relative;
    padding: 3px 8px 12px;
    font-size: 14px;
    cursor: pointer;
    color: rgb(100, 116, 145);
    border: none !important;
    font-weight: 600;
    background: #fff;
    // border-bottom: 3px solid #fff !important;
  }

  ul > li.active > a,
  ul > li.active > a:focus,
  ul > li.active > a:hover {
    color: rgb(8, 15, 26) !important;
    border-bottom: 3px solid rgb(5, 102, 255) !important;
    background: #fff !important;
    font-weight: 600 !important;
  }

  li > a:hover {
    background: #fff !important;
  }
  // ul > li > a:hover {
  //   color: rgb(8, 15, 26);
  //   border-bottom: 1px solid rgb(5, 102, 255);
  // }
`;

export {
  MemberImg,
  Members,
  More,
  DataWrapperClass,
  QuestionsContainer,
  InsightWrapper,
  FlexRow,
  FlexItem,
  InsightFilter,
  InsightTitle,
  InlineItems,
  InsightContent,
  InsightRow,
  LoaderWrapper,
  ChartWrapper,
  ItemSearch,
  HeaderData,
  SoundButton
};



// WEBPACK FOOTER //
// src/modules/screens/reporting/styles.js